import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export const Story = ({ content }) => {
  const { t } = useLang();
  if (!content) return null;
  const title = content.title || t("story.fallbackTitle");
  const body = content.body || "";
  return (
    <section id="about" data-testid="story-section" className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative">
          <div className="aspect-[4/5] overflow-hidden rounded-sm">
            <img src="https://images.pexels.com/photos/30403192/pexels-photo-30403192.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940"
                 alt="Findivine relief reaching a rural elder in India"
                 className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-primary text-primary-foreground px-7 py-5 max-w-[220px]">
            <p className="font-serif text-lg leading-tight">{t("story.badge")}</p>
          </div>
        </motion.div>

        <div className="lg:col-span-7 lg:pl-8">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-xs tracking-[0.3em] uppercase font-bold text-primary mb-6">{t("story.eyebrow")}</motion.p>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground leading-[1.05] mb-7">
            {title}
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}
            className="text-lg text-muted-foreground leading-relaxed max-w-xl whitespace-pre-wrap">
            {body}
          </motion.p>
          <motion.a href="#donate" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
            className="mt-9 inline-flex items-center gap-2 text-sm font-semibold text-foreground border-b-2 border-primary pb-1 hover:gap-3 transition-all">
            {t("story.cta")}
          </motion.a>
        </div>
      </div>
    </section>
  );
};
